import { ICommand, IQuery } from 'core-ts-types';
import { ISectionsDatasource } from '../../../views/sections/datasources/sections_datasource';
import * as _4 from 'lodash4';
import { ISection } from '../../../interfaces/scheduler_interfaces';

export class SectionActionButtonController {
  private section: ISection;
  private canAddToWaitlist: boolean;
  constructor(
    private $stateParams: ng.ui.IStateParamsService,
    private scheduleSectionCommand: ICommand,
    private $state: ng.ui.IStateService
  ) {}
  $onInit() {
    this.canAddToWaitlist = false;
  }
}

angular.module('capability-ng-scheduler').component('swap_section_button', {
  templateUrl: 'capability-ng-scheduler/src/components/section_action_button/section_action_button.html',
  controller: SectionActionButtonController,
  bindings: {
    section: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/components/calendar_scheduled_section_swap_button/calendar_scheduled_section_swap_button.ts